export const SESSION_TIMER_PRODUCT = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
};

export const SESSION_TIMER_URGENT_SECONDS = 120;
export const SESSION_TIMER_TICK_MS = 1000;
export const SESSION_TIMER_WAIT_MS = 500;
export const SESSION_TIMER_COPY = {
  MINS_LEFT: 'Mins left',
};
